import React from 'react'
import SeoMetaData from '@/components/SeoMetaData'

export default function MuveszetNapja() {
  return (
    <>
      <SeoMetaData
        seoTitle="Művészet Napja Játék | BeArt Művészetterápia"
        seoDescription="Játssz a Művészet Napja játékkal a BeArt oldalon!"
      />

      <div className="h-[calc(100dvh-60px-64px)] w-full overflow-hidden">
        <iframe
          title="Művészet Napja Játék"
          src="/muveszetnapja-game/index.html"
          allow="midi"
          className="h-full w-full border-0"
        />
      </div>
    </>
  )
}

